import React from 'react'
import './ffl-signup.scss'
import CommonApi from '../../apis/common'
import DropdownV2 from '../common/dropdown-v2/dropdown'
import DropdownV3 from '../common/dropdown-v3/dropdown'
import { getImageSource } from '../../utility/image-source'
import { Constants, ImageConstants } from '../../constants/constants'
import CommonUtils from '../../utility/common-utilities'
import Loading from '../common/loading/loading'



class FflSignup extends React.Component {

    state = {
        reloadCountryCode: false,
        reloadDropdown: true,
        isLoading: false
    }

    countryCodeHash = {}
    cityHash = {}

    componentDidMount() {
        this.getCities()
        this.getCountryCodes()

        setTimeout(() => {
            this.onSelect({
                "title": "India +91",
                "addOn": "India",
                "value": "+91"
            }, "countryCode")
        }, 100);


    }

    getCountryCodes(payload = {}) {
        CommonApi.getCountryCodeList(payload)
            .then(response => {
                let data = response.response
                if (data.length) {
                    this.setState({ countryList: data })
                    let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                    this.setState({ countryCodeDropdown, reloadCountryCode: true }, () => {
                        this.setState({ reloadCountryCode: false })
                    })
                }
            })
            .catch(err => { console.log(err) })
    }

    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = []
        let localHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]
            if (!localHash[item.dialCode]) {
                this.countryCodeHash[item.dialCode] = item
                localHash[item.dialCode] = item
                countryCodeDropdown.push({
                    title: `${item.name} ${item.dialCode}`,
                    addOn: item.name,
                    value: item.dialCode
                })
            }
        }
        this.setState({ hashedCountryCode: this.countryCodeHash })
        return countryCodeDropdown
    }

    onCountryCodeSearch(value, index) {
        if (value.length > 2 || !value) {
            this.countryCodeIndex = index
            this.getCountryCodes({ name: `/${value}` })
        }
    }

    getCities(payload = {}) {
        CommonApi.getCities(payload)
            .then(response => {
                let cities = response.response
                let citiesDropdown = []
                cities.forEach(element => {
                    this.cityHash[element._id] = element

                    let cityName = `${element.name}, ${element.state || element.country || ""}${element.state ? `, ${element.country}` : ""}`
                    citiesDropdown.push({ title: cityName, value: element._id })
                });
                this.cityHash["OTHER"] = { name: "Others", state: "Other", country: "Other" }
                citiesDropdown.push({ title: "Others", value: "OTHER" })
                console.log(citiesDropdown)
                this.setState({ citiesDropdown, reloadDropdown: false })
            }).catch(err => {
            })
    }

    onCitySearch(value) {
        console.log(value)
        if (value.length >= 3) {
            let payload = { name: `/${value}` }
            this.getCities(payload)
        } else if (!value) {
            this.getCities()
        }
    }


    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            if (key === 'emailId') {
                this.setState({
                    isEmailAlreadyRegistered: false,
                    otpSend: false,
                    isSubmit: false
                })
            }
            this.validatePayload()
        })
    }


    onSelect = (option, key) => {
        console.log(option)
        this.setState({ [key]: option?.value }, _ => {
            this.validatePayload()
            // if (key === "city" && option?.value) {
            //     let cityInfo = this.cityHash[option?.value]
            //     if (cityInfo.countryCode) {
            //         this.setState({
            //             countryCode: cityInfo.countryCode
            //         }, _ => {
            //             if (this.countryCodeDropdownRef) {
            //                 this.countryCodeDropdownRef.clearAll()
            //                 if (this.state.hashedCountryCode && this.state.hashedCountryCode[cityInfo.countryCode]) {
            //                     const countryCodeData = this.state.hashedCountryCode[cityInfo.countryCode]
            //                     this.countryCodeDropdownRef.onClickOption({
            //                         title: `${countryCodeData.name} ${countryCodeData.dialCode}`,
            //                         addOn: countryCodeData.name,
            //                         value: countryCodeData.dialCode
            //                     })
            //                 }
            //             }
            //         })
            //     } else {
            //         this.setState({ countryCode: "", reloadCountryCode: true }, () => {
            //             this.setState({ reloadCountryCode: false })
            //         })
            //     }
            // }
        })
    }

    onBlurEmailInput = event => {
        let value = event.target.value

        if (value) {
            let isValid = CommonUtils.validateEmail(event.target.value)
            if (!isValid)
                this.setState({ isInvalidEmail: true }, _ => {
                    this.validatePayload()
                })
            else
                this.setState({ isInvalidEmail: false }, _ => {
                    this.validatePayload()
                })
        } else {
            if (this.state.isInvalidEmail)
                this.setState({ isInvalidEmail: false }, _ => {
                    this.validatePayload()
                })
        }
    }

    onClickAccept(key) {
        let value = this.state[key]
        this.setState({ [key]: !value }, () => {
            this.validatePayload()
        })
    }

    sendFFLReport = _ => {
        this.setState({ showError: true })
        let isValid = this.validatePayload()

        if (!isValid) return
        this.setState({ isSubmit: true, isLoading: true })
        const { emailId, name, countryCode, mobileNumber, city, studyingInClass } = this.state

        let cityInfo = this.cityHash[city]

        let payload = {
            email: emailId,
            name: name,
            countryCode: countryCode,
            mobileNumber: mobileNumber,
            studyingInClass: studyingInClass ? studyingInClass : "No",
            city: cityInfo.name,
            state: cityInfo.state,
            country: cityInfo.country
        }

        console.log(payload)

        CommonApi.createFFLCurriculumDownloadedUserInfo(payload)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        showSuccessScreen: true,
                        isEmailAlreadyRegistered: false,
                        isLoading: false
                    })
                }
            })
            .catch((err, res) => {
                if (err?.response?.data?.code === 11000) {
                    this.setState({
                        isEmailAlreadyRegistered: true
                    })
                } else if (err?.response?.data?.message === 'Invalid email') {
                    this.setState({
                        isInvalidEmail: true
                    })
                }
                this.setState({ isSubmit: false, isOtpSubmit: false })
            })
    }


    validatePayload = isOTP => {
        this.setState({
            isValidForm: false,
            isNotAgree: false
        })
        let countryCodeDetail = this.state.hashedCountryCode[this.state.countryCode]
        let validateCountryCode = CommonUtils.validateMobileNumber(
            this.state.mobileNumber,
            countryCodeDetail
        )
        if (!validateCountryCode) {
            this.setState({ isInvalidMobile: true })
            return false
        } else {
            this.setState({ isInvalidMobile: false })
        }

        // if (!this.validateClass()) return false

        // if (!this.state.feeStructure) {
        //   this.setState({ isInvalidFeeStructure: false })
        //   return false
        // }

        // if (!this.validateRole()) return false

        // if (!this.validateBoard()) return false

        if (!this.state.name) return false

        if (!this.state.emailId || this.state.isInvalidEmail) return false

        // if (!this.state.schoolName) return false

        if (!this.state.countryCode) return false

        if (!this.state.mobileNumber.trim()) return false

        // if (!this.state.role) return false

        if (!this.state.city) return false

        // if(!this.state.studyingInClass) return false

        // if (!this.state.branch) return false
        // if (!this.state.isAccept) {
        //     this.setState({ isNotAgree: true })
        //     return false
        // }
        if (!this.state.isAgree) {
            this.setState({ isNotAgree: true })
            return false
        }



        // if (isOTP && !this.state.otp) return false
        this.setState({
            isValidForm: true
        })
        return true
    }

    render() {


        if (this.state.showSuccessScreen) {
            return (
                <div>Report Send to You</div>
            )
        }

        const {
            countryCode,
            name,
            city,
            mobileNumber,
            emailId,
            isInvalidEmail,
            isInvalidMobile,
            isEmailAlreadyRegistered,
            studyingInClass,
            showError
        } = this.state

        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='ffl-signup center-box '>

                    <div className='row mt-5 justify-content-center ml-3'>
                        <div className='col-lg-5 col-md-6 col-sm-12'>Download the Foundation of Financial Literacy curriculum </div>
                    </div>

                    <div className='row justify-content-center mt-3'>
                        <div className='col-lg-5 col-md-6 col-sm-12'>
                            <div className='cw-card'>
                                <div className='cw-card-body'>
                                    <div className='row'>
                                        <div className='col'>
                                            <label className='cw-input-label'>
                                                NAME
                                                <span className='star'>*</span>
                                            </label>
                                            <input
                                                className={`cw-input ${showError && !name ? 'invalid' : ''}`}
                                                placeholder='Enter Your Name'
                                                value={name}
                                                onChange={e => this.onChangeHandler(e, 'name')}
                                            />
                                            {showError && !name && (
                                                <span className='invalid-text'>
                                                    Please enter Your name
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className='row bw-spaces-input'>
                                        <div className='col'>
                                            <label className='cw-input-label'>MOBILE NUMBER</label>
                                            <span className='star'>*</span>
                                        </div>
                                    </div>
                                    <div className='row phone-number-container'>
                                        <div className='d-inline-block mr-2' style={{ width: '25%' }}>
                                            {!this.state.reloadCountryCode ?
                                                <DropdownV2
                                                    key='countryCodeOnly'
                                                    keyText="countryCodeOnly"
                                                    text='title'
                                                    placeholder='Search country code'
                                                    searchable
                                                    options={this.state.countryCodeDropdown}
                                                    invalid={showError && !countryCode}
                                                    onSelect={option => this.onSelect(option, 'countryCode')}
                                                    value={countryCode ? countryCode : ''}
                                                    allOptions={this.state.countryCodeDropdown}
                                                    onSearch={value => this.onCountryCodeSearch(value)}
                                                    style={{ background: '#F6F7F5' }}
                                                    ref={ref => this.countryCodeDropdownRef = ref}
                                                />
                                                : ""
                                            }
                                        </div>
                                        <div className='d-inline-block' style={{ width: '70%' }}>
                                            <input
                                                className={`cw-input ${(isInvalidMobile && mobileNumber) ||
                                                    (showError && !mobileNumber)
                                                    ? 'invalid'
                                                    : ''}`}
                                                placeholder='Enter Your Mobile Number'
                                                onChange={e => this.onChangeHandler(e, 'mobileNumber')}
                                                value={mobileNumber}
                                            />
                                        </div>
                                        <div className='col'>
                                            {showError && !mobileNumber && (
                                                <span className='invalid-text'>
                                                    Please enter phone number
                                                </span>
                                            )}
                                            {isInvalidMobile && mobileNumber && (
                                                <span className='invalid-text'>
                                                    Enter valid mobile number
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className='row bw-spaces-input'>
                                        <div className='col'>

                                            <label className='cw-input-label'>EMAIL ID
                                                <span className='star'>*</span>
                                            </label>
                                            <input
                                                className={`cw-input ${(isInvalidEmail && emailId) ||
                                                    (showError && !emailId)
                                                    ? 'invalid'
                                                    : ''
                                                    }`}
                                                placeholder='Enter Your Email Id'
                                                onChange={e => this.onChangeHandler(e, 'emailId')}
                                                onBlur={this.onBlurEmailInput}
                                                onFocus={this.onFocusEmailInput}
                                                value={emailId}
                                                disabled={this.props.isProfile}
                                            />

                                            {isInvalidEmail && emailId && (
                                                <span className='invalid-text'>Enter valid email</span>
                                            )}
                                            {showError && !emailId && (
                                                <span className='invalid-text'>Please enter email</span>
                                            )}
                                            {isEmailAlreadyRegistered && (
                                                <span className='invalid-text'>
                                                    The email is already in use. Please use a new email.{' '}
                                                </span>
                                            )}
                                        </div>
                                    </div>


                                    <div className='mt-3 mb-2  '>Do You have a Child Studying in Class 6 - 9 ?</div>
                                    <div onChange={e => this.onChangeHandler(e, "studyingInClass")}>
                                        <input className='' type="radio" value="Yes" name="class" /> <span className='ml-1'>Yes</span>
                                        <input className='ml-5 ' type="radio" value="No" name="class" /><span className='ml-2'>No</span>
                                        {/* {showError && !studyingInClass && (
                                            <span className='invalid-text'>Please Select Studying in Class</span>
                                        )} */}
                                    </div>

                                    <div className='row bw-spaces-input'>
                                        <div className='col'>
                                            <label className='cw-input-label'>CITY</label>
                                            {!this.state.reloadDropdown ?
                                                <DropdownV3
                                                    key='city-drop-down'
                                                    text='title'
                                                    placeholder='Search City'
                                                    searchable
                                                    options={this.state.citiesDropdown}
                                                    invalid={showError && !city}
                                                    onSelect={option => this.onSelect(option, 'city')}
                                                    value={city ? city : ''}
                                                    onSearch={value => this.onCitySearch(value)}
                                                    style={{ background: '#F6F7F5' }}
                                                /> : ""
                                            }

                                            {showError && !city && (
                                                <span className='invalid-text'>Please enter city</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className='px-4 py-2'>
                                        <div className="row mt-3">
                                            <div className="col-1 px-0 text-right">
                                                <img className={`check cursor-pointer `} alt="" onClick={() => this.onClickAccept("isAgree")} src={getImageSource(this.state.isAgree ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} />
                                            </div>
                                            <div className="col">
                                                <p>I aggree to allow Countingwell to contact me on Email and/or Whatsapp</p>
                                            </div>
                                        </div>

                                        {
                                            this.state.showError && this.state.isNotAgree ?
                                                <div className="row">
                                                    <div className="col">
                                                        <span className='invalid-text'>Please select above checkbox</span>
                                                    </div>
                                                </div> : ""
                                        }
                                    </div>

                                    <div className='d-flex justify-content-center cursor-pointer' onClick={() => this.sendFFLReport()}>
                                        <div className={`submit-button ${this.state.isValidForm ? 'active-button' : 'in-active-button'}`}>Send me this Report</div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </>

        )
    }


}

export default FflSignup;